/**
 * @author mi
 * @date 2019/8/06
 * @project zujuanzaixian
 */
export const renderMathML = _.debounce(function () {
  if (window.MathJax) {
    if (typeof window.Symbol === 'function' && typeof MathJax.typesetPromise === 'function') {
      MathJax.typesetPromise().then(res => {
        console.log(res, 'res')
      }).catch(err => {
        console.log(err)
      })
    } else {
      MathJax.Hub && MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
    }
  }
}, { leading: true })
